import React, { Component } from 'react';
import { Form, Card, Button, Col, Jumbotron, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from './menu'
import errores from '../middleware/errordb'
import back from '../back.svg';
import config from '../config';
import Mensajes from './subcomponent/mensajes';
import ModalConfirm from './subcomponent/modalConfirm';

class FormularioEmpresa extends Component {
    constructor(props) {
        super(props);
        //const usuarioMofificar = this.props
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Empresas",
            mostrarMensaje: false,
            msg: 0,
            comp: "",
            empresa: currentCompany,
            tipo: currentUserType,
            departamentos: [],
            ciudades: [],
            id_company: "",
            ID_EMPRESA: "",
            CODIGO_EMPRESA: "",
            NIT_DV: "",
            RAZON_SOCIAL: "",
            NOMBRE_ESTABLECIMIENTO: "",
            TIPO_DOCUMENTO: "",
            REGIMEN: "",
            PARTICIPANTE: "1",
            CODIGO_PAIS: "",
            DEPARTAMENTO: "",
            CODIGO_DEPARTAMENTO: "",
            CIUDAD: "",
            CODIGO_CIUDAD: "",
            BARRIO: "",
            DIRECCION: "",
            TELEFONO: "",
            CELULAR: "",
            NOTA1: "",
            NOTA2: "",
            NOTA3: "",
            NOTA_POS: "",
            ESTADO: "",
            URL_API: "",
            TOKEN: "",
            TOKEN_FECHA_VENCIMIENTO: "",
            COMFIAR_USUARIO: "",
            COMFIAR_PASS: "",
            FORMATO_ID: "",
            PRUEBAS: "",
            CIIU: "",
            RESPONSABILIDAD: "",
            RESP_IVA: "",
            DESCR_RESP_IVA: "",
            tipo_usuario: "",
            buttonmsg: "",
            mensaje: "",
            O13: false,
            O15: false,
            O23: false,
            O47: false,
            R99: false
        }
    }

    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/companies/dep-city/', datasend)
            .then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    this.setState({ ciudades: datos[0], departamentos: datos[1] })
                } else {
                    //console.log(data.message);
                }

                ////console.log(data[0]['ID_USUARIO']);
            });
        const { search } = this.props.location;
        let titulo = "";
        let id_company = "";
        const empresaEdicion = search.replace('?', '');
        if (empresaEdicion) {
            titulo = "Modificar Empresas";
            id_company = empresaEdicion
            fetch(config.servBackEnd + '/companies/' + empresaEdicion, datasend)
                .then(response => response.json())
                .then(data => {
                    const datos = data.data[0];
                    if (data.ok) {
                        this.setState({
                            ID_EMPRESA: (datos[0]["ID_EMPRESA"]) ? datos[0]["ID_EMPRESA"] : "",
                            CODIGO_EMPRESA: (datos[0]["CODIGO_EMPRESA"]) ? datos[0]["CODIGO_EMPRESA"] : "",
                            NIT_DV: (datos[0]["NIT_DV"]) ? datos[0]["NIT_DV"] : "",
                            RAZON_SOCIAL: (datos[0]["RAZON_SOCIAL"]) ? datos[0]["RAZON_SOCIAL"] : "",
                            NOMBRE_ESTABLECIMIENTO: (datos[0]["NOMBRE_ESTABLECIMIENTO"]) ? datos[0]["NOMBRE_ESTABLECIMIENTO"] : "",
                            TIPO_DOCUMENTO: (datos[0]["TIPO_DOCUMENTO"]) ? datos[0]["TIPO_DOCUMENTO"] : "",
                            REGIMEN: (datos[0]["REGIMEN"]) ? datos[0]["REGIMEN"] : "",
                            PARTICIPANTE: (datos[0]["PARTICIPANTE"]) ? datos[0]["PARTICIPANTE"] : "",
                            CODIGO_PAIS: (datos[0]["CODIGO_PAIS"]) ? datos[0]["CODIGO_PAIS"] : "",
                            DEPARTAMENTO: (datos[0]["DEPARTAMENTO"]) ? datos[0]["DEPARTAMENTO"] : "",
                            CODIGO_DEPARTAMENTO: (datos[0]["CODIGO_DEPARTAMENTO"]) ? datos[0]["CODIGO_DEPARTAMENTO"] : "",
                            CIUDAD: (datos[0]["CIUDAD"]) ? datos[0]["CIUDAD"] : "",
                            CODIGO_CIUDAD: (datos[0]["CODIGO_CIUDAD"]) ? datos[0]["CODIGO_CIUDAD"] : "",
                            BARRIO: (datos[0]["BARRIO"]) ? datos[0]["BARRIO"] : "",
                            DIRECCION: (datos[0]["DIRECCION"]) ? datos[0]["DIRECCION"] : "",
                            TELEFONO: (datos[0]["TELEFONO"]) ? datos[0]["TELEFONO"] : "",
                            CELULAR: (datos[0]["CELULAR"]) ? datos[0]["CELULAR"] : "",
                            FECHA_REGISTRO: (datos[0]["FECHA_REGISTRO"]) ? datos[0]["FECHA_REGISTRO"] : "",
                            NOTA1: (datos[0]["NOTA1"]) ? datos[0]["NOTA1"] : "",
                            NOTA2: (datos[0]["NOTA2"]) ? datos[0]["NOTA2"] : "",
                            NOTA3: (datos[0]["NOTA3"]) ? datos[0]["NOTA3"] : "",
                            NOTA_POS: (datos[0]["NOTA_POS"]) ? datos[0]["NOTA_POS"] : "",
                            LOGO: (datos[0]["LOGO"]) ? datos[0]["LOGO"] : "",
                            ESTADO: (datos[0]["ESTADO"]) ? datos[0]["ESTADO"] : "",
                            URL_API: (datos[0]["URL_API"]) ? datos[0]["URL_API"] : "",
                            TOKEN: (datos[0]["TOKEN"]) ? datos[0]["TOKEN"] : "",
                            TOKEN_FECHA_VENCIMIENTO: (datos[0]["TOKEN_FECHA_VENCIMIENTO"]) ? datos[0]["TOKEN_FECHA_VENCIMIENTO"] : "",
                            COMFIAR_USUARIO: (datos[0]["COMFIAR_USUARIO"]) ? datos[0]["COMFIAR_USUARIO"] : "",
                            COMFIAR_PASS: (datos[0]["COMFIAR_PASS"]) ? datos[0]["COMFIAR_PASS"] : "",
                            CREATE_AT: (datos[0]["CREATE_AT"]) ? datos[0]["CREATE_AT"] : "",
                            UPDATE_AT: (datos[0]["UPDATE_AT"]) ? datos[0]["UPDATE_AT"] : "",
                            FORMATO_ID: (datos[0]["FORMATO_ID"]) ? datos[0]["FORMATO_ID"] : "",
                            PRUEBAS: (datos[0]["PRUEBAS"]) ? datos[0]["PRUEBAS"] : "",
                            CIIU: (datos[0]["CIIU"]) ? datos[0]["CIIU"] : "",
                            RESPONSABILIDAD: (datos[0]["RESPONSABILIDAD_FISCAL"]) ? datos[0]["RESPONSABILIDAD_FISCAL"] : "",
                            RESP_IVA: (datos[0]["REGIMEN_FISCAL"]) ? datos[0]["REGIMEN_FISCAL"] : "",
                            DESCR_RESP_IVA: (datos[0]["DESCRICION_REG_FACTURA"]) ? datos[0]["DESCRICION_REG_FACTURA"] : ""
                        })
                        this.validarRespo((datos[0]["RESPONSABILIDAD_FISCAL"]) ? datos[0]["RESPONSABILIDAD_FISCAL"] : "")
                    } else {
                        //console.log(data.message);
                    }

                    ////console.log(data[0]['ID_USUARIO']);
                });
        } else {
            titulo = "Crear Empresas";
            id_company = "";
        }
        this.setState({ titulo, id_company })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({show: false});
        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA: this.state.ID_EMPRESA,
                CODIGO_EMPRESA: this.state.CODIGO_EMPRESA,
                NIT_DV: this.state.NIT_DV,
                RAZON_SOCIAL: this.state.RAZON_SOCIAL,
                NOMBRE_ESTABLECIMIENTO: this.state.NOMBRE_ESTABLECIMIENTO,
                TIPO_DOCUMENTO: this.state.TIPO_DOCUMENTO,
                REGIMEN: this.state.REGIMEN,
                PARTICIPANTE: this.state.PARTICIPANTE,
                CODIGO_PAIS: this.state.CODIGO_PAIS,
                DEPARTAMENTO: this.state.DEPARTAMENTO,
                CODIGO_DEPARTAMENTO: this.state.CODIGO_DEPARTAMENTO,
                CIUDAD: this.state.CIUDAD,
                CODIGO_CIUDAD: this.state.CODIGO_CIUDAD,
                BARRIO: this.state.BARRIO,
                DIRECCION: this.state.DIRECCION,
                TELEFONO: this.state.TELEFONO,
                CELULAR: this.state.CELULAR,
                //FECHA_REGISTRO : this.state.FECHA_REGISTRO,
                NOTA1: this.state.NOTA1,
                NOTA2: this.state.NOTA2,
                NOTA3: this.state.NOTA3,
                NOTA_POS: this.state.NOTA_POS,
                LOGO: this.state.LOGO,
                ESTADO: this.state.ESTADO,
                URL_API: this.state.URL_API,
                //TOKEN : this.state.TOKEN,
                //TOKEN_FECHA_VENCIMIENTO : this.state.TOKEN_FECHA_VENCIMIENTO,
                COMFIAR_USUARIO: this.state.COMFIAR_USUARIO,
                COMFIAR_PASS: this.state.COMFIAR_PASS,
                FORMATO_ID: this.state.FORMATO_ID,
                PRUEBAS: this.state.PRUEBAS,
                CIIU: this.state.CIIU,
                RESPONSABILIDAD_FISCAL: this.state.RESPONSABILIDAD,
                REGIMEN_FISCAL: this.state.RESP_IVA,
                DESCRICION_REG_FACTURA : this.state.DESCR_RESP_IVA
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': this.state.ID_EMPRESA
            }
        }

        if (this.state.id_company === "") {
            ruta = config.servBackEnd + '/companies/create';
        } else {
            ruta = config.servBackEnd + '/companies/modify';
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_company: this.state.ID_EMPRESA })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Empresa con errores:" + errores[data.code] +" " + data.message })
                }
                //this.s
                //this.setState({ data })
            });
        //});
        event.preventDefault();
    }

    validarRespo =(data)=>{
        const newdata = data.split(";");
        let tmpO13 = false;
        let tmpO15 = false;
        let tmpO23 = false;
        let tmpO47 = false;
        let tmpR99 = false;
        newdata.forEach(element => {
            if(element === "O-13")  tmpO13 =true;
            if(element === "O-15")  tmpO15 =true;
            if(element === "O-23")  tmpO23 =true;
            if(element === "O-47")  tmpO47 =true;
            if(element === "R-99-PN")  tmpR99 =true;
        });
        this.setState({
            O13: tmpO13, 
            O15: tmpO15, 
            O23: tmpO23, 
            O47: tmpO47, 
            R99: tmpR99 
        })
    }
    CheckedRespo=({target})=>{
        let finalString="";
        const { id } = target;
        const { checked } = target;
        const tmpResponsabilidad = this.state.RESPONSABILIDAD.split(";");
        const confirm = tmpResponsabilidad.findIndex(function (element) {
            return element === id;
        });
        if (checked) {
            if (confirm < 0) tmpResponsabilidad.push(id);
        } else {
            if (confirm >= 0) tmpResponsabilidad.splice(confirm, 1);
        }
        tmpResponsabilidad.forEach(element => {
            if(element!=="") finalString += element+";";           
        });
        finalString = finalString.substr(0, finalString.length -1)
        this.validarRespo(finalString);
        this.setState({ RESPONSABILIDAD: finalString })
    }

    handleClose = () => {
        this.setState({show: false});
    };

    render() {
        const mensajeBoton = (this.state.id_company === "") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_clientes === "0") ? '¿Esta seguro que desea crear la empresa?' : '¿Esta seguro que desea modificar la empresa?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        const rutaBack = (this.state.tipo === '0') ? '/empresa' : '/home';
        const ciudades = this.state.ciudades;
        const departamentos = this.state.departamentos;
        const currentDep = this.state.CODIGO_DEPARTAMENTO;
        return (
            <div className="FormularioEmpresa">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Atras</Tooltip>}>
                            <div className="div-back">
                                <a href={rutaBack}>
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>

                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridEstado">
                                            <Form.Label>TIPO DOCUMENTO</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ TIPO_DOCUMENTO: e.target.value })} value={this.state.TIPO_DOCUMENTO} required disabled={this.state.tipo === '1'}>
                                                <option value="">Seleccione</option>
                                                <option value="11">Registro civil</option>
                                                <option value="12">Tarjeta de identidad</option>
                                                <option value="13">Cedula de ciudadania</option>
                                                <option value="21">Tarjeta de extranjeria</option>
                                                <option value="22">Cedula de extranjeria</option>
                                                <option value="31">NIT</option>
                                                <option value="41">Pasaporte</option>
                                                <option value="42">Documento de identificación extranjero</option>
                                                <option value="50">NIT de otro pais</option>
                                                <option value="91">NUIP</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridEmpresa">
                                            <Form.Label>NIT - DV</Form.Label>
                                            <InputGroup>
                                                <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ ID_EMPRESA: e.target.value })} value={this.state.ID_EMPRESA} required disabled={this.state.tipo === '1'} />
                                                <Form.Control type="text" placeholder="DV" onChange={e => this.setState({ NIT_DV: e.target.value })} value={this.state.NIT_DV} required disabled={this.state.tipo === '1'} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridEmpresa">
                                            <Form.Label>Tipo Organizacion</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ PARTICIPANTE: e.target.value })} value={this.state.PARTICIPANTE} required >
                                                <option value="">Seleccione</option>
                                                <option value="1">Persona Juridica</option>
                                                <option value="2">Persona Natural</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridEmpresa">
                                            <Form.Label>Regimen Fiscales</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ RESP_IVA: e.target.value })} value={this.state.RESP_IVA} required >
                                                <option value="">Seleccione</option>
                                                <option value="48">Responsable de IVA</option>
                                                <option value="49">No responsable de IVA</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridNombre">
                                            <Form.Label>NOMBRE EMPRESA</Form.Label>
                                            <Form.Control type="text" placeholder="Nombre" onChange={e => this.setState({ RAZON_SOCIAL: e.target.value.toUpperCase() })} value={this.state.RAZON_SOCIAL} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridCiiu">
                                            <Form.Label>NOMBRE ESTABLECIMIENTO</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ NOMBRE_ESTABLECIMIENTO: e.target.value })} value={this.state.NOMBRE_ESTABLECIMIENTO} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridCiiu">
                                            <Form.Label>CIIU</Form.Label>
                                            <Form.Control type="text" placeholder="0000" onChange={e => this.setState({ CIIU: e.target.value })} value={this.state.CIIU} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridBarrio">
                                            <Form.Label>BARRIO</Form.Label>
                                            <Form.Control type="text" placeholder="Barrio" onChange={e => this.setState({ BARRIO: e.target.value.toUpperCase() })} value={this.state.BARRIO} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridDepartamento">
                                            <Form.Label>DEPARTAMENTO</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_DEPARTAMENTO: e.target.value, CODIGO_CIUDAD: "", DEPARTAMENTO: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_DEPARTAMENTO} required>
                                                <option key='d' value="">--Seleccione Departamento--</option>
                                                {departamentos.map(function (currentData, index) {
                                                    return <option key={'d' + index} value={currentData.CODIGO_DEPARTAMENTO}>{currentData.NOMBRE_DEPARTAMENTO}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridCiudad">
                                            <Form.Label>CIUDAD</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_CIUDAD: e.target.value, CIUDAD: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_CIUDAD} required>
                                                <option key='d' value="">--Seleccione Ciudad--</option>
                                                {ciudades.map(function (currentData, index) {
                                                    if (currentData.CODIGO_DEPARTAMENTO === currentDep) {
                                                        return <option key={'d' + index} value={currentData.CODIGO_DEPARTAMENTO + currentData.CODIGO_MUNICIPIO}>{currentData.NOMBRE_MUNICIPIO}</option>;
                                                    } else {
                                                        return null;
                                                    }
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridDireccion">
                                            <Form.Label>DIRECCION</Form.Label>
                                            <Form.Control type="text" placeholder="Cll 1 No 1 - 123" onChange={e => this.setState({ DIRECCION: e.target.value.toUpperCase() })} value={this.state.DIRECCION} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridTelefono">
                                            <Form.Label>TELEFONO</Form.Label>
                                            <Form.Control type="text" placeholder="(2)7654321" onChange={e => this.setState({ TELEFONO: e.target.value })} value={this.state.TELEFONO} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridCelular">
                                            <Form.Label>CELULAR</Form.Label>
                                            <Form.Control type="text" placeholder="300332211" onChange={e => this.setState({ CELULAR: e.target.value })} value={this.state.CELULAR} required />
                                        </Form.Group>
                                    </Form.Row>
                                    RESPONSABILIDADES FISCALES
                                    <Form.Row>
                                        <Form.Group as={Col}  controlId="O-13">
                                            <Form.Check type="checkbox" label="O-13 Gran Contribuyente" onChange={this.CheckedRespo}  checked={this.state.O13} />
                                        </Form.Group>
                                        <Form.Group as={Col}  controlId="O-15">
                                            <Form.Check type="checkbox" label="O-15 Autorretenedor" onChange={this.CheckedRespo} checked={this.state.O15} />
                                        </Form.Group>
                                        <Form.Group as={Col}  controlId="O-23">
                                            <Form.Check type="checkbox" label="O-23 Agente de retencion IVA" onChange={this.CheckedRespo} checked={this.state.O23} />
                                        </Form.Group>
                                        <Form.Group as={Col}  controlId="O-47">
                                            <Form.Check type="checkbox" label="O-47 Regimen simple de tributacion" onChange={this.CheckedRespo} checked={this.state.O47} />
                                        </Form.Group>
                                        <Form.Group as={Col}  controlId="R-99-PN">
                                            <Form.Check type="checkbox" label="R-99-PN No responsable" onChange={this.CheckedRespo} checked={this.state.R99} />
                                        </Form.Group>                                        
                                    </Form.Row>
                                   {/*  <Form.Group as={Col} controlId="formGridEmpresa">
                                        <Form.Label>Responsabilidades Fiscales</Form.Label>
                                        <Form.Control as="select" custom="true" onChange={e => this.setState({ RESPONSABILIDAD: e.target.value })} value={this.state.RESPONSABILIDAD} required >
                                            <option value="">Seleccione</option>
                                            <option value="O-13">O-13 Gran Contribuyente</option>
                                            <option value="O-15">O-15 Autorretenedor</option>
                                            <option value="O-23">O-23 Agente de retencion IVA</option>
                                            <option value="O-47">O-47 Regimen simple de tributacion</option>
                                            <option value="R-99-PN">R-99-PN No responsable</option>
                                        </Form.Control>
                                    </Form.Group> */}
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridNota1">
                                            <Form.Label>DESCRIPCION REGIMEN PARA IMPRESION DE FACTURA</Form.Label>
                                            <Form.Control type="text"  onChange={e => this.setState({ DESCR_RESP_IVA: e.target.value })} value={this.state.DESCR_RESP_IVA} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridNota1">
                                            <Form.Label>OBSERVACION 1</Form.Label>
                                            <Form.Control type="text" placeholder="obs . . ." onChange={e => this.setState({ NOTA1: e.target.value })} value={this.state.NOTA1} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridNota2">
                                            <Form.Label>OBSERVACION 2</Form.Label>
                                            <Form.Control type="text" placeholder="obs . . ." onChange={e => this.setState({ NOTA2: e.target.value })} value={this.state.NOTA2} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridNota3">
                                            <Form.Label>OBSERVACION 3</Form.Label>
                                            <Form.Control type="text" placeholder="obs . . ." onChange={e => this.setState({ NOTA3: e.target.value })} value={this.state.NOTA3} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                    <Form.Group as={Col} controlId="formGridNotapos">
                                            <Form.Label>OBSERVACION FACTURA POS</Form.Label>
                                            <Form.Control as="textarea" rows="3" onChange={e => this.setState({ NOTA_POS: e.target.value })} value={this.state.NOTA_POS} required />
                                        </Form.Group>
                                    </Form.Row>
                                    {(this.state.tipo === '0') &&
                                        <div>
                                            <h3>Zona Exclusiva de FACTURAR365 </h3>
                                            <Form.Row>
                                                <Form.Group as={Col} controlId="formGridDireccion">
                                                    <Form.Label>URL API</Form.Label>
                                                    <Form.Control type="text" placeholder="Cll 1 No 1 - 123" onChange={e => this.setState({ URL_API: e.target.value })} value={this.state.URL_API} required />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formGridTelefono">
                                                    <Form.Label>COMFIAR USUARIO</Form.Label>
                                                    <Form.Control type="text" placeholder="(2)7654321" onChange={e => this.setState({ COMFIAR_USUARIO: e.target.value })} value={this.state.COMFIAR_USUARIO} required />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formGridCelular">
                                                    <Form.Label>COMFIAR_PASS</Form.Label>
                                                    <Form.Control type="text" placeholder="300332211" onChange={e => this.setState({ COMFIAR_PASS: e.target.value })} value={this.state.COMFIAR_PASS} required />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formGridCelular">
                                                    <Form.Label>FORMATO ID</Form.Label>
                                                    <Form.Control type="text" placeholder="300332211" onChange={e => this.setState({ FORMATO_ID: e.target.value })} value={this.state.FORMATO_ID} required />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="formGridCelular">
                                                    <Form.Label>PRUEBA (produccion = 1 , pruebas = 2)</Form.Label>
                                                    <Form.Control type="text" placeholder="1-2" onChange={e => this.setState({ PRUEBAS: e.target.value })} value={this.state.PRUEBAS} required />
                                                </Form.Group>
                                            </Form.Row>
                                        </div>

                                    }
                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (FormularioEmpresa);
//<-- disabled={!this.validateForm()} -->